module.exports = __webpack_public_path__ + "img/page-05.0c98bdd5.png";